import React from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';

import './MainMenu.scss';

export const MainMenu = (props) => {
  MainMenu.propTypes = {
    items: PropTypes.array.isRequired
  };

  const { items } = props;

  return (
    <div className="main-menu">
      {items.map((item, index) => {
        return (
          <div key={index} className="main-menu-item">
            {item.external ? (<a href={item.to} >{item.title}</a>) : (<Link to={item.to} >{item.title}</Link>)}
          </div>
        );
      })}
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/Menu/MainMenu.js